import { render, staticRenderFns } from "./AddEditTrip.vue?vue&type=template&id=952e0c4c&scoped=true&"
import script from "./AddEditTrip.vue?vue&type=script&lang=js&"
export * from "./AddEditTrip.vue?vue&type=script&lang=js&"
import style0 from "./AddEditTrip.vue?vue&type=style&index=0&id=952e0c4c&scoped=true&lang=scss&"
import style1 from "./AddEditTrip.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952e0c4c",
  null
  
)

export default component.exports